// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBmDe3Xbo7jlt28pfHe_q-vZnTtVAuFN9w",
  authDomain: "ecommerce-e986a.firebaseapp.com",
  projectId: "ecommerce-e986a",
  storageBucket: "ecommerce-e986a.appspot.com",
  messagingSenderId: "846178921917",
  appId: "1:846178921917:web:68b377678665c3d322f6d4"
};

// Initialize Firebase
initializeApp(firebaseConfig);